import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import locale from 'element-ui/lib/locale';
import elementEn from 'element-ui/lib/locale/lang/en'
import elementZh from 'element-ui/lib/locale/lang/zh-CN'
import en from './en'
import zh from './zh'
Vue.use(VueI18n)
const messages = {
  en: {
    ...en,
    ...elementEn
  },
  zh: {
    ...zh,
    ...elementZh
  }
}
const i18n = new VueI18n({
  // locale: localStorage.lang || 'zh',
  locale: 'en',
  messages
})
// locale.i18n((key, value) => i18n.t(key, value))
export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js